import { config } from "@/config";
import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: config.sentry.enabled,
  dsn: config.sentry.dsn,
  environment: config.sentry.environment,
  release: config.github.sentryRelease,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [config.hosts.api, window.location.origin],
    }),
    Sentry.feedbackIntegration({
      isNameRequired: true,
      autoInject: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [config.hosts.api, window.location.origin],
  beforeSend: (event, hint) => {
    console.error(hint.originalException || hint.syntheticException);
    if (config.sentry.enabled) {
      return event;
    } else {
      console.log(event);
      return null;
    }
  },
});

export default Sentry;
